import BlogImage1 from 'images/news/blogs/avia-animal-rescue-jiabao/1.webp'
import BlogImage2 from 'images/news/blogs/avia-animal-rescue-jiabao/2.webp'
import BlogImage3 from 'images/news/blogs/avia-animal-rescue-jiabao/3.webp'
import BlogImage4 from 'images/news/blogs/avia-animal-rescue-jiabao/4.webp'
import CoverImage from 'images/news/blogs/avia-animal-rescue-jiabao/cover.webp'
import { TextLink } from '../../../components'
import { joinDomain } from '../../../utils'
import { NewsCategory, NewsItem } from '../home'
import { AviaAnimalRescueJiabaoRoute, AviaPetAdoptionTangtangRoute } from '../route'
import { BlogData, BlogModule } from './const'

export const AviaAnimalRescueJiabao: BlogData = {
  key: 'avia-animal-rescue-jiabao',
  title: 'Meet Our Office Cats: Jiabao, Gentle Soul, Fierce Spirit',
  tag: NewsCategory.SocialResponsibility,
  date: 'Aug 08, 2025',
  content: [
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          At Avia, our Office Cat program wasn’t just about rescuing animals—it was about finding those who needed us
          most. And sometimes, those very animals find us first.
          <br />
          <br />
          This is the story of Jiabao.
        </>
      ),
    },
    {
      type: BlogModule.Title,
      value: <>A Cat with No Teeth, but an Overflowing Heart</>,
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          When we met Jiabao for the first time, he didn’t hesitate. While the other rescue cats remained cautious and
          quiet, he ran straight toward us, wrapped himself around a team member’s leg, and began climbing up like a
          tiny tree climber. Just like a dog might do.
          <br />
          <br />
          It was his way of saying, “Pick me.”
          <br />
          <br />
          And we did.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage1,
      },
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Jiabao was saved through <strong>animal rescue</strong> from a difficult environment in Beijing. He had been
          living as a stray, and by the time he was found, he was in critical condition—malnourished, dehydrated, and
          suffering from severe oral inflammation. The infection was so advanced he could no longer eat. His only chance
          of survival? A full-mouth dental extraction.
          <br />
          <br />
          He has no teeth. Not a single one.
          <br />
          <br />
          But that never stopped him.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage2,
      },
    },
    {
      type: BlogModule.Title,
      value: <>The Bravest Soul in the Room</>,
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Despite everything he’s been through, Jiabao is known in our office for his confidence and charm. He’s soft
          and small, but carries himself with surprising poise—walking with a little bounce in his step and a spark in
          his eye.
          <br />
          <br />
          He’s the first to approach new visitors. The first to meow when he hears someone open the fridge. And the
          first to crawl into someone’s lap when he senses they’re having a rough day.
          <br />
          <br />
          He may not have teeth, but he has something better: a deep emotional intelligence and an uncanny sense of
          timing. Jiabao doesn’t just ask for affection—he gives it.
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage3,
      },
    },
    {
      type: BlogModule.Title,
      value: <>A Tiny Body, an Enormous Will to Live</>,
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Jiabao’s health journey hasn’t been easy. Even after coming to Avia, he’s battled life-threatening infections,
          each time teetering on the edge. More than once, we thought we might lose him.
          <br />
          <br /> But Jiabao never gave up. He fought through every round of treatment with quiet determination—and
          always bounced back. No complaints. No fear. Just that same gentle presence, always returning to curl up in
          someone’s lap as if to say, “I’m still here.”
        </>
      ),
    },
    {
      type: BlogModule.Image,
      value: {
        image: BlogImage4,
      },
    },
    {
      type: BlogModule.Title,
      value: <>Jiabao Is the Reminder We All Needed</>,
    },
    {
      type: BlogModule.Paragraph,
      value: (
        <>
          Jiabao may not be the strongest, the fluffiest, or the loudest cat. But he’s the one who chose us. The one who
          teaches us that vulnerability isn’t weakness—it’s connection.
          <br />
          <br />
          He reminds us that even when you’ve lost your voice, your teeth, or your strength—you can still choose love.
          You can still show up.
          <br />
          <br />
          Today, he shares Avia’s office cat room with his best friend,{' '}
          <TextLink href={AviaPetAdoptionTangtangRoute}>Tangtang</TextLink>. Together, they’ve turned a simple corner of
          our workspace into a sanctuary of softness, calm, and care.
        </>
      ),
    },
  ],
  more: [],
  path: joinDomain(AviaAnimalRescueJiabaoRoute),
}

export const AviaAnimalRescueJiabaoNews: NewsItem = {
  id: 17,
  image: CoverImage,
  breadcrumb: [AviaAnimalRescueJiabao.tag, AviaAnimalRescueJiabao.date],
  title: AviaAnimalRescueJiabao.title,
  url: AviaAnimalRescueJiabao.path,
}
